"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { clearStoredAttribution, recordAttribution } from "@/lib/attribution";
import { CONSENT_EVENT, readConsent } from "@/lib/consent";

/**
 * Houdt bij via welk kanaal een bezoeker binnenkwam (UTM-tags, verwijzer, klik-ID), zodat de
 * kassa dat bij de bestelling kan bewaren (lib/attribution.ts). Rendert niets.
 *
 * Toestemming (zie lib/consent.ts): bijhouden mag pas bij analytics-toestemming; klik-ID's
 * (fbclid/gclid/ttclid) alleen bij marketing-toestemming. Wordt toestemming ingetrokken, dan wordt
 * de bewaarde herkomst gewist. Zolang de keuze nog niet is gelezen (eerste render) wordt er niets
 * gewist en niets bijgehouden.
 */
export default function AttributionTracker() {
  const pathname = usePathname();
  const [toestemming, setToestemming] = useState<{ analytics: boolean; marketing: boolean } | null>(null);

  useEffect(() => {
    const update = () => {
      const c = readConsent();
      setToestemming({ analytics: !!c?.analytics, marketing: !!c?.marketing });
    };
    update();
    window.addEventListener(CONSENT_EVENT, update);
    return () => window.removeEventListener(CONSENT_EVENT, update);
  }, []);

  useEffect(() => {
    if (!toestemming) return;
    if (!toestemming.analytics) {
      clearStoredAttribution();
      return;
    }
    recordAttribution({ allowClickId: toestemming.marketing });
  }, [pathname, toestemming]);

  return null;
}
